import { render, staticRenderFns } from "./ResultadoIndicadores.vue?vue&type=template&id=6ac1664c"
import script from "./ResultadoIndicadores.vue?vue&type=script&lang=js"
export * from "./ResultadoIndicadores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports